import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

//*MUI
import { Box, Modal, Divider } from '@mui/material';
import EditIcon from '../../Components/Icons/EditIcon';


//*Redux
import { useDispatch } from 'react-redux';
import action from '../../Redux Store/actions';

//*files
import cssClasses from "./ChangeUnitStatus.module.css"
import Button from '../../Subcomponents/Button';
import Close from '../../Components/Icons/Close';
import { getAllInventoryStatusFromTable, getUnitByUnitNo, UpdateLeadIdToInventory } from '../../Services/SustenanceService';
import DropDown from '../../Subcomponents/DropDown';
import { getUnitStatus, UpdateUnitStatus } from '../../Services/Event';
import { errorTost, infoTost, successTost } from '../../Services/Toast';
import { insertInventoryLogs } from '../../Services/AllAllotments';
import { useSelector } from 'react-redux';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'fit-Content',
  height: 'fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function ChangeUnitStatus({ open, handleClose, RespValue, unit }) {
  console.log('unit: ', unit);
  // let { unitNo } = useParams();
  const dispatch = useDispatch();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  // const [Units, setUnits] = useState([]);
  const [StatusList, setStatusList] = useState([]);

  const [ChangeUnitStatusDetails, setChangeUnitStatusDetails] = useState({
    UnitStatus: '',
    unitStatusString: ''
  });

  const [HelperText, setHelperText] = useState({
    UnitStatus: '',
  })
  useEffect(() => {
    dispatch(action.activeMenu('inventory'));
    getProject();
  }, []);



  function getProject() {
    // getUnitByUnitNo(unitNo).then((res) => {
    //   console.log("Units" , res)
    //   setUnits(res.data[0])
    // })
    getAllInventoryStatusFromTable().then((resp) => {
      console.log("resp=>", resp)
      setStatusList([...resp.data])

      // getUnitStatus(unit.unitId.unitId).then((response22) => {
      //   console.info("Status-of-unit" , response22[0].InventoryStatus.inventoryStatusId)
      //    setChangeUnitStatusDetails((pre) => {
      //     pre.UnitStatus = response22[0]?.inventoryStatusId;
      //     return {...pre}
      //    })
      //     const data = resp.data.filter(f => f.inventoryStatusId !==  response22[0].InventoryStatus.inventoryStatusId && f.status !== "Payment Pending")
      //     console.log("arr" , data)        
      //     setStatusList([...data])
      //    })
    })
  }

  function UpdateStatus() {
    getUnitStatus(unit.unitId.unitId).then((response) => {
      console.info("Unit-Status", response)
      if (response[0].InventoryStatus.inventoryStatusId !== ChangeUnitStatusDetails.UnitStatus) {
        UpdateUnitStatus(ChangeUnitStatusDetails.UnitStatus, unit.unitId.unitId).then((rep) => {
          console.info("Status-Updated", rep);
          let InventoryLogObj = {
            userId: loggedInUser?.userId,
            status: ChangeUnitStatusDetails.unitStatusString,
            unitId: unit.unitId.unitId
          }
          insertInventoryLogs(InventoryLogObj).then((insertInventoryLogsRes) => {
            console.log({ insertInventoryLogsRes });
          }).catch((err) => {
            console.log('err while inserting into inventory log', err);
          });
        })

        // ! check if status changed from 'On Hold' to available; then only update
        if (unit.leadId) {
          let leadObj = {
            leadId: null,
          };
          UpdateLeadIdToInventory(leadObj, unit.unitId.unitId).then((resp) => {
            console.log("leadId-set-to-null", resp)
          })
        }
        handleClose();
        successTost('Unit Status Updated')
        unit.unitId.inventoryStatusId.inventoryStatusId = ChangeUnitStatusDetails.UnitStatus;
        unit.unitId.inventoryStatusId.status = ChangeUnitStatusDetails.unitStatusString;
        RespValue(unit)
      } else {
        infoTost("Unit Status already updated!")
      }

    })

  }

  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>Unit : {unit?.unitId?.unitNo}</Box>{' '}
                  <Box mt={0.4}>
                    <EditIcon color={'#000000'} fill={'none'} />
                  </Box>
                </Box>
                <Box className={cssClasses.bhkTitle}>{unit?.inventoryTypeId?.type}</Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box width={'100%'} height={'49%'} overflow={'auto'}>
            <Box margin={"3rem"} className={cssClasses.ThirdDiv}>
              <Box className={cssClasses.InputTitle} mt={1.5}>
                Unit Status :{' '}
              </Box>
              <Box className={cssClasses.widthBox}>
                <DropDown

                  placeHolder={'Select'}
                  list={StatusList.map((element, id) => {
                    return {
                      label: element.status,
                      value: element.inventoryStatusId,
                    };
                  })}
                  selectedValue={ChangeUnitStatusDetails.UnitStatus}
                  onChangeSelect={(value) => {
                    setChangeUnitStatusDetails((pre) => {
                      pre.UnitStatus = value;
                      console.log("value", value);
                      return { ...pre };
                    });
                    let selectedStatus;
                    selectedStatus = StatusList.filter(
                      ({ inventoryStatusId }) => inventoryStatusId === value
                    );
                    console.log(selectedStatus[0].status);
                    setChangeUnitStatusDetails((pre) => {
                      pre.unitStatusString = selectedStatus[0].status;
                      return { ...pre };
                    });
                    if (ChangeUnitStatusDetails.UnitStatus !== "") {
                      HelperText.UnitStatus = "";
                    } else {
                      HelperText.UnitStatus =
                        "Please select unit status";
                    }
                  }}
                  style={{
                    background: "#F2F4F7",
                    selectedColor: "#667085",
                  }}
                  helperText={HelperText.UnitStatus}
                />
              </Box>
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    fontSize: '1.4rem',
                    lineHeight: '2rem',
                    color: '#344054',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '0.4rem',
                  }}
                  padding={'0.85rem 2.6rem'}
                  btnName={'Discard'}
                  clicked={handleClose}
                />
              </Box>

              <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: '#007FFF',
                    borderRadius: '0.4rem',
                  }}
                  padding={'0.65rem 3.2rem'}
                  disable={ChangeUnitStatusDetails.UnitStatus === ''}
                  btnName={'Save'}
                  clicked={UpdateStatus}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ChangeUnitStatus